
import { Component, Vue } from 'vue-property-decorator'
import InputTextBase from '@/components/atoms/InputTextBase.vue'

/**
 * パスワード入力欄
 */
@Component({
  components: {
    InputTextBase,
  },
})
export default class InputText extends Vue {
  /**
   * 入力時のイベント
   *
   * @param value 入力値
   */
  private inputEvent(value: string): void {
    this.$emit('input', value)
  }
}
